<header class="header">
  <a [routerLink]="['/']" class="header__logo pointer">
    <img
      [height]="32"
      [ngSrc]="'/assets/logos/makersite-logo.svg'"
      [priority]="true"
      [width]="32"
      alt="Makersite Logo"
      class="header__logo-img"
      />
  </a>
  @if (!isExternalSupplier) {
    <div class="header__search">
      <app-header-search [focusOff]="focusOutGlobalSearch"></app-header-search>
    </div>
  }
  <div class="header__actions">
    @if (!isExternalSupplier) {
      <div class="menu-btn-div">
        <button
          mat-icon-button
          class="new-item"
          (focus)="focusOffGlobalSearch()"
          (click)="onCreateNewItem()"
          aria-label="Create new item"
          [matTooltip]="'Create new item'"
          matTooltipHideDelay="300"
          >
          <mds-icon [height]="24" [width]="24" [key]="icons.PLUS" [pathColors]="['#fff']"></mds-icon>
        </button>
      </div>
    }
    <div class="menu-btn-div">
      <button
        mat-icon-button
        [matMenuTriggerFor]="menuSuport"
        [matTooltip]="'Help & Support'"
        matTooltipShowDelay="300"
        aria-label="Help & Support"
        tabindex="0"
        (focus)="focusOffGlobalSearch()"
        >
        <mds-icon [height]="24" [key]="icons.INFO" [pathColors]="['#fff']" [width]="24"></mds-icon>
      </button>
      <mat-menu #menuSuport="matMenu">
        @if (isTutorialEnabled()) {
          <button
            tabindex="0"
            (click)="showInlineManual()"
            aria-label="Tutorial"
            class="menu-btn"
            mat-menu-item
            role="menuitem"
            >
            <mds-icon [height]="20" [key]="icons.BOOK" [pathColors]="['#547080']" [width]="20"></mds-icon>
            Tutorial
          </button>
        }
        <button tabindex="0" (click)="openFAQ()" aria-label="FAQ" class="menu-btn" mat-menu-item role="menuitem">
          <mds-icon [height]="20" [key]="icons.FAQ" [pathColors]="['#547080']" [width]="20"></mds-icon>
          FAQ
        </button>
        <a
          tabindex="0"
          href="https://everycs.atlassian.net/servicedesk/customer/portals"
          target="_blank"
          aria-label="Support center"
          class="menu-btn"
          mat-menu-item
          role="menuitem"
        >
          <mds-icon [height]="20" [key]="icons.CHAT_BUBBLE" [pathColors]="['#547080']" [width]="20"></mds-icon>
          Support center
        </a>
        <button
          tabindex="0"
          (click)="privacyPolicy()"
          aria-label="Privacy"
          class="menu-btn"
          mat-menu-item
          role="menuitem"
          >
          <mds-icon [height]="20" [key]="icons.PRIVACY_POLICY" [pathColors]="['#547080']" [width]="20"></mds-icon>
          Privacy Policy
        </button>
      </mat-menu>
    </div>
    @if (teamList.length > 1 && !hideTeamSwitch) {
      <div class="menu-btn-div">
        <button
          mat-icon-button
          [matMenuTriggerFor]="menuTeams"
          [matTooltip]="'Change Team'"
          matTooltipShowDelay="300"
          aria-label="Change Team"
          tabindex="0"
          (focus)="focusOffGlobalSearch()"
          >
          <mds-icon [height]="24" [key]="icons.TEAMS" [pathColors]="['#fff']" [width]="24"></mds-icon>
        </button>
        <mat-menu #menuTeams="matMenu">
          @for (team of teamList; track team) {
            <button
              class="menu-btn"
              [attr.aria-label]="team.name"
              mat-menu-item
              role="menuitem"
              (click)="switchTeam(team)"
              >
              <mds-icon [height]="24" [key]="icons.GROUP" [pathColors]="['#547080']" [width]="20"></mds-icon>
              {{ team.name }}
            </button>
          }
        </mat-menu>
      </div>
    }
    <div [ngClass]="{ loading: isReloading$ | async }" class="header__reload menu-btn-div">
      <button
        tabindex="0"
        mat-icon-button
        (click)="reloadPage()"
        (dblclick)="clearCache()"
        aria-label="Reload"
        [matTooltip]="'Reload'"
        class="menu-btn"
        [attr.data-testid]="'Reload'"
        >
        <mds-icon [height]="24" [key]="icons.RELOAD" [pathColors]="['#fff']" [width]="24"></mds-icon>
      </button>
    </div>

    <div class="header__profile">
      <app-header-profile tabindex="0"></app-header-profile>
    </div>
  </div>
</header>
